"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SbModalFooter = exports._SbModalFooter = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactIntl = require("react-intl");

var _shapes = require("../../skybase-core/shapes");

var _sbModalI18n = require("./sb-modal-i18n");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * @typedef {Object} skybase-components.sb-modal.sb-modal-footer#props
 *
 * @property {Function} onBtnClick
 */

/**
 * @function
 * @name skybase-components.sb-modal.sb-modal-footer#SbModalFooter
 * @param  {skybase-components.sb-modal.sb-modal-footer#props} props
 * @return {React.Component}
 */
// eslint-disable-next-line no-underscore-dangle
var _SbModalFooter = function _SbModalFooter(props) {
  var onBtnClick = props.onBtnClick,
      _ = props.intl.formatMessage;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "sb-modal-footer fl-container fl-justify-end"
  }, /*#__PURE__*/_react.default.createElement("button", {
    className: "sb-btn",
    onClick: onBtnClick,
    type: "button"
  }, _(_sbModalI18n.messages.OK)));
};

exports._SbModalFooter = _SbModalFooter;
_SbModalFooter.propTypes = {
  onBtnClick: _propTypes.default.func,
  intl: _shapes.intlShape.isRequired
};
_SbModalFooter.defaultProps = {
  onBtnClick: function onBtnClick() {}
};
var SbModalFooter = (0, _reactIntl.injectIntl)(_SbModalFooter);
exports.SbModalFooter = SbModalFooter;
//# sourceMappingURL=sb-modal-footer.js.map